import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Trash2 } from 'lucide-react';
import { TOOL_MAP } from './tool-definitions';
import { useTooltip } from './Tooltip';
import { useTranslation } from 'react-i18next';

export default function Toolbar({ viewer }) {
    const { t } = useTranslation();
    const [realButtons, setRealButtons] = useState([]);
    const [clearButtonNode, setClearButtonNode] = useState(null);

    const { showTooltip, hideTooltip } = useTooltip();

    useEffect(() => {
        if (!viewer) return;

        const originalToolsContainer = document.getElementById('tools');
        const originalClippingContainer = document.getElementById('clipping_tools');
        if (!originalToolsContainer || !originalClippingContainer) return;

        const foundButtons = [];

        Object.keys(TOOL_MAP).forEach(toolKey => {
            const tool = TOOL_MAP[toolKey];
            const potreeName = tool.potreeName;
            const i18nName = tool.i18n;

            const selector = `img[title="${potreeName}"], img[data-i18n="${i18nName}"]`;
            const realButtonNode = originalToolsContainer.querySelector(selector) ||
                originalClippingContainer.querySelector(selector);

            if (realButtonNode) {
                foundButtons.push({
                    key: toolKey,
                    name: tool.name,
                    potreeName,
                    i18nName,
                    icon: tool.icon,
                    node: realButtonNode
                });
            } else {
                console.warn(`Toolbar setup: Could not find real Potree button for: ${tool.name}`);
            }
        });

        setRealButtons(foundButtons);

        // Handle the clear button separately
        const clearSelector = `img[title="Remove all measurements"], img[data-i18n="[title]tt.remove_all_measurement"]`;
        const clearBtnNode = originalToolsContainer.querySelector(clearSelector) ||
            originalClippingContainer.querySelector(clearSelector);

        if (clearBtnNode) {
            setClearButtonNode(clearBtnNode);
        } else {
            console.warn("Toolbar setup: Could not find Potree Clear Scene button");
        }
    }, [viewer]);

    const handleToolClick = (button) => {
        button.node.click();
    };

    return (
        <motion.div
            className="toolbar"
            initial={{ y: 100, x: "-50%", opacity: 0 }}
            animate={{ y: 0, x: "-50%", opacity: 1 }}
            transition={{ duration: 0.1, ease: "easeOut" }}
        >
            {realButtons.map(button => (
                <motion.button
                    key={button.key}
                    className="toolbar-button"
                    onClick={() => handleToolClick(button)}
                    whileTap={{ scale: 0.8 }}
                    onMouseEnter={(e) => showTooltip(t(`toolbar.tooltips.${button.key}`), e)}
                    onMouseLeave={hideTooltip}
                >
                    {button.icon}
                </motion.button>
            ))}

            <div className="toolbar-divider" />

            {clearButtonNode && (
                <motion.button
                    className="toolbar-button danger-button"
                    onClick={() => clearButtonNode.click()}
                    whileTap={{ scale: 0.8 }}
                    onMouseEnter={(e) => showTooltip(t("toolbar.actions.removeAll"), e)}
                    onMouseLeave={hideTooltip}
                >
                    <Trash2 size={22} color="white" />
                </motion.button>
            )}
        </motion.div>
    );
}
